// extracted by mini-css-extract-plugin
module.exports = {"srOnly":"_1Cx3VIf","noTitle":"_1xmpDrE _1Cx3VIf","asosFocus":"_19mnudD"};